import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeOne from './pages/homepages/HomeOne';
import HomeTwo from './pages/homepages/HomeTwo';
import HomeThree from './pages/homepages/HomeThree';
import HomeFour from './pages/homepages/HomeFour';
import AboutUs from './pages/innerpages/AboutUs';
import OurTeam from './pages/innerpages/OurTeam';
import Price from './pages/innerpages/Price';
import ContactUs from './pages/innerpages/ContactUs';
import ProjectsOne from './pages/projectpages/ProjectsOne';
import ProjectsTwo from './pages/projectpages/ProjectsTwo';
import ProjectsDetails from './pages/projectpages/ProjectsDetails';
import PostsOne from './pages/blogpages/PostsOne';
import PostsTwo from './pages/blogpages/PostsTwo';
import PostsThree from './pages/blogpages/PostsThree';
import PostsFour from './pages/blogpages/PostsFour';
import PostsDetailsOne from './pages/blogpages/PostsDetailsOne';
import PostsDetailsTwo from './pages/blogpages/PostsDetailsTwo';
import PostsDetailsThree from './pages/blogpages/PostsDetailsThree';
import Error from './pages/innerpages/Error';

function App() {
  return (
    <Router>
        <Routes>
          <Route exact path='/' element={<HomeOne/>}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-2'}`} element={<HomeTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-3'}`} element={<HomeThree />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-4'}`} element={<HomeFour />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-4'}`} element={<HomeFour />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/about-us'}`} element={<AboutUs />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/team'}`} element={<OurTeam />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/price'}`} element={<Price />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/contact-us'}`} element={<ContactUs />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/projects-fullwidth-three-column'}`} element={<ProjectsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/projects-fullwidth-two-column'}`} element={<ProjectsTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/single-project'}`} element={<ProjectsDetails />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-posts-fullwidth'}`} element={<PostsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-posts-fullwidth-two-column'}`} element={<PostsTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-posts-left-sidebar'}`} element={<PostsThree />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-posts-right-sidebar'}`} element={<PostsFour />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/single-post'}`} element={<PostsDetailsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-single'}`} element={<PostsDetailsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/single-post-fullwidth'}`} element={<PostsDetailsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/single-post-left-sidebar'}`} element={<PostsDetailsTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/single-post-right-sidebar'}`} element={<PostsDetailsThree />}/>
          <Route path='*' element={<Error/>}/>        
        </Routes>
    </Router>
  );
}

export default App;
